import * as types from "./ActionTypes";
import { addActiveApiCall } from "./ActiveApiActions";
import * as FaqApi from "../../apis/revshare/FaqApi";

export function loadFaQsSuccess(questions) {
  return { type: types.LOAD_FAQS_SUCCESS, questions };
}

export function addFaqSuccess(question) {
  return { type: types.SAVE_NEW_FAQ_SUCCESS, question };
}

export function updateFaqSuccess(question) {
  return { type: types.UPDATE_FAQ_SUCCESS, question };
}

export function updateFaqUsefulnessScoreSuccess(question) {
  return { type: types.UPDATE_USEFULNESS_SCORE_SUCCESS, question };
}

export function removeFaqSuccess(questionId, wasRemoved) {
  return { type: types.REMOVE_FAQ_SUCCESS, questionId, wasRemoved };
}

export function loadFaQs() {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_FAQS_SUCCESS));
    return FaqApi.getFAQs()
      .then(questions => dispatch(loadFaQsSuccess(questions)))
      .catch(error => {
        throw error;
      });
  };
}

export function updateFaqUsefulnessScore(questionId, scoreChange) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.UPDATE_USEFULNESS_SCORE_SUCCESS));
    return FaqApi.updateUsefulnessScore(questionId, scoreChange)
      .then(question => dispatch(updateFaqUsefulnessScoreSuccess(question)))
      .catch(error => {
        throw error;
      });
  };
}

export function addFaq(question) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.SAVE_NEW_FAQ_SUCCESS));
    return FaqApi.addFAQ(question)
      .then(question => dispatch(addFaqSuccess(question)))
      .catch(error => {
        throw error;
      });
  };
}

export function editFaq(questionId, question) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.UPDATE_FAQ_SUCCESS));
    return FaqApi.updateQuestion(questionId, question)
      .then(question => dispatch(updateFaqSuccess(question)))
      .catch(error => {
        throw error;
      });
  };
}

export function removeFaq(questionId) {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.REMOVE_FAQ_SUCCESS));
    return FaqApi.removeFAQ(questionId)
      .then(wasRemoved => dispatch(removeFaqSuccess(questionId, wasRemoved)))
      .catch(error => {
        throw error;
      });
  };
}
